// Import repository modules
import FaqModule from '@/repository/modules/faq'
import MarketingModule from '@/repository/modules/marketing'
import AdminModule from '~/repository/modules/admin'
import AuthModule from '~/repository/modules/auth'
import CompanyModule from '~/repository/modules/company'
import DashboardModule from '~/repository/modules/dashboard'
import JobModule from '~/repository/modules/job'
import LandingPageModule from '~/repository/modules/landingpage'
import MasterModule from '~/repository/modules/master'
import MediaModule from '~/repository/modules/media'
import MyJobModule from '~/repository/modules/my-job'
import NotificationModule from '~/repository/modules/notification'
import ProfileModule from '~/repository/modules/profile'

interface IApiInstance {
  auth: AuthModule
  profile: ProfileModule
  admin: AdminModule
  master: MasterModule
  media: MediaModule
  job: JobModule
  dashboard: DashboardModule
  myJob: MyJobModule
  company: CompanyModule
  notification: NotificationModule
  landingPage: LandingPageModule
  faq: FaqModule
  marketing: MarketingModule
}

export default defineNuxtPlugin(() => {
    // An object containing all repositories we need to expose
    const modules: IApiInstance = {
        auth: new AuthModule(),
        profile: new ProfileModule(),
        admin: new AdminModule(),
        master: new MasterModule(),
        media: new MediaModule(),
        job: new JobModule(),
        dashboard: new DashboardModule(),
        myJob: new MyJobModule(),
        company: new CompanyModule(),
        notification: new NotificationModule(),
        landingPage: new LandingPageModule(),
        faq: new FaqModule(),
        marketing: new MarketingModule(),
  }

    return {
        provide: {
            api: modules,
    }
    }
})
